const WORDS = ["Consulenza", "Formazione", "Sviluppo", "Ascolto", "Valore", "Supporto"];

function Row() {
    return (
        <div className="flex shrink-0 items-center">
            {WORDS.map((w) => (
                <span key={w} className="flex items-center">
                    <span className="px-8 font-serif text-4xl italic text-outline-cream sm:text-5xl">{w}</span>
                    <span className="h-2 w-2 rounded-full bg-[#D4A5A5]/60" />
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <div
            data-testid="editorial-marquee"
            aria-hidden="true"
            className="overflow-hidden border-y border-[#FAF7F2]/10 bg-[#1A1A1A] py-8"
        >
            <div className="marquee-track flex w-max">
                <Row />
                <Row />
            </div>
        </div>
    );
}
